import React, { useState, useEffect } from 'react'
import moment from 'moment'
import { useParams } from 'react-router-dom'
import { Button, Modal } from 'syngenta-react-components'
import { getProductionPlan, postScaleTicket } from '../../../services/apiHelper'
// import { AuthContext } from '../../../services/context'
import Widget from '../../../dpe-usco/components/Widget/Widget'
import Table from '../../../dpe-usco/components/Table/Table'
import TableStatus from '../../../components/subComponents/TableStatus/TableStatus'

const FuelDeliveryWidget = ({ data, status, growerName, contract_year, external_reference_id , isZeroOut }) => {
  const [ modalVisible, setModalVisible ] = useState(false)
  const [ error, setError ] = useState(false)
  const [ loading, setLoading ] = useState(false)
  const [ totals, setTotals ] = useState({ contracted_units: 0, harvested_units: 0, delivered_units: 0 })
  const { company_id } = useParams()

  const structure =  {
    headers: [
      'Delivery month',
      'Contracted bu.',
      'Harvested bu.',
      'Delivered bu.'
    ],
    dataKeys: [
      'delivery_month',
      'contracted_units',
      'harvested_units',
      'delivered_units'
    ],
    rowFormat: {
      contracted_units: {
        format: contracted_units => {
          return <span>{`${contracted_units}`}</span>
        }
      },
      harvested_units: {
        format: harvested_units => {
          return <span>{`${harvested_units}`}</span>
        }
      },
      delivered_units: {
        format: delivered_units => {
          return <span>{`${delivered_units}`}</span>
        }
      }
    }
  }

  useEffect(() => {
    let totalContracted = 0
    let totalHarvested = 0
    let totalDelivered = 0
    if(data){
      data.forEach(month => {
        totalContracted += month.contracted_units
        totalHarvested += month.harvested_units
        totalDelivered += month.delivered_units
      })
      const temp = { contracted_units: totalContracted, harvested_units: totalHarvested, delivered_units: totalDelivered }
      setTotals(temp)
    }
  }, [data, setTotals])

  useEffect(() => {
    if(isZeroOut){
      // setZeroInventory(true)
    }
  }, [isZeroOut])

  const bottomRow = !status ? (
    <div className='bt1-s-lightgray df jcfe aic h44 pl16 fw700 fz15'>
      <div className='flx1 mr25'></div>
      <div className='flx1 df jcfs mr25'>{totals.contracted_units}</div>
      <div className='flx1 df jcfs mr25'>{totals.harvested_units}</div>
      <div className='flx1 df jcfs mr25'>{totals.delivered_units}</div>
    </div>
  )
    :
    null
  
  const ZeroOutInventoryModal = () => {
    const onOkay = async () => {
      setLoading(true)
      const plans= await getProductionPlan(
        company_id,
        'company_id',
        true
      )
      const currentProductionPlanYear = plans.filter(plan => plan.contract_year === parseInt(contract_year.split('-')[0]))
      const zeroOutString = `zero-out-${Math.random().toString(36).substr(2, 5)}`
      const zeroOutData = { 
        scale_tickets: [
          {
            bill_of_landing_number: zeroOutString,
            external_reference_id: external_reference_id,
            damage: zeroOutString,
            foreign_material: zeroOutString,
            gross_lbs: zeroOutString,
            gross_quantity: zeroOutString,
            grower_name: growerName,
            moisture: zeroOutString,
            net_lbs: zeroOutString,
            net_quantity: (totals.harvested_units - totals.delivered_units).toString(),
            production_plan_id: currentProductionPlanYear[0].production_plan_id,
            rapid_visco_analyzer: zeroOutString,
            scale_ticket_number: zeroOutString,
            scale_ticket_date: new Date (moment().format('MM/DD/YY')),
            tar_lbs: zeroOutString,
            test_weight: zeroOutString
          }
        ]
      }
      let response = await postScaleTicket(zeroOutData)
      if (response.status === 200) {
        setLoading(false)
        setModalVisible(false)
        // setZeroInventory(true)
      } else {
        setError(true)
      }
    }
    return (
      <Modal
        autoHeight
        show={modalVisible}
        handleClose={() => setModalVisible(false)}
      >
        <div className='w100% tal h100% bgc-white bd1-s-lightgray bxshmodal bdrs-4 mb40'>
          <div className='bb1-s-lightgray df jcsb'>
            <div className='df ml15 mt15 mb15'>
              <div className='fw600 ml10'>
              Zero out inventory?
              </div>
            </div>
          </div>
          {error ? <div className='pt10 tac c-red'>An Error Has Occured, Please Retry.</div> : null}
          {loading ? <div className="df aic jcc h80"> <div className='loader h40 w40'/> </div> :
            <div className='p25 h80 df aic jcfs'>
              This will set the total inventory as 0. This action cannot be undone.
            </div>
          }
          <div className='bt1-s-lightgray df aic jcfe'>
            <div className='mt8 mb8 mr8'>
              <Button customClassName='mr8 miw75 pl1 pr1' text='Cancel' onClick={() => setModalVisible(false)}/>
              <Button customClassName={`miw70 ${loading? 'op.4' : ''}`} type='success' text='Ok' disabled={loading} onClick={() => onOkay()}/>
            </div>
          </div>
        </div>
      </Modal>
    )
  }
  return (
    <>
      <ZeroOutInventoryModal />
      <Widget title="Delivery" dataTestId='fuelDeliveryTable' 
        // button={renderButton()} 
      >
        <Table
          scrollbar
          data={data}
          structure={structure}
          statusComponent={
            status ? (
              <TableStatus
                status={status}
                prompt={'No data'}
              />
            ) : null
          }
          bottomOfTable={bottomRow}
        />
        <div className='mt16 bd1-s-lightgray df jcsb aic h44 pl16 fw700 bdrs-4 fz15 '>
          <p className='p0 flx3 mr75 tal'>Total inventory</p>
          <div className='flx1 mr25'>{isZeroOut ? '0' : totals.harvested_units - totals.delivered_units}</div>
        </div>
      </Widget>
    </>
  )
}

export default FuelDeliveryWidget
